var isTablet = function () {
    return window.innerWidth >= ICF.Variables.Breakpoints.Tablet && window.innerWidth < ICF.Variables.Breakpoints.DesktopSm;
};

module.exports = isTablet;